import { render, staticRenderFns } from "./surface_post_being_showed_new.vue?vue&type=template&id=41218340&scoped=true&"
import script from "./surface_post_being_showed_new.vue?vue&type=script&lang=ts&"
export * from "./surface_post_being_showed_new.vue?vue&type=script&lang=ts&"
import style0 from "./surface_post_being_showed_new.vue?vue&type=style&index=0&id=41218340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41218340",
  null
  
)

export default component.exports